import { useEffect, useState } from "react";
import { useGLTF } from "@react-three/drei";
useGLTF.preload("./models/hub_baked_1.glb");

import { images, audios, subtitles } from "../assets/assets";

export default function preloadAssets() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    async function preload() {
      // 1. Précharge le modèle GLTF via drei

      // 2. Précharge les images
      const imageUrls = [
        images.photo,
        images.mailDesktopBackground,
        images.fragmentSvg,
        images.mailDesktopIcon,
        images.mobileBackground,
      ];

      const loadImages = () =>
        Promise.all(
          imageUrls.map(
            (src) =>
              new Promise((resolve) => {
                const img = new window.Image();
                img.src = src;
                img.onload = resolve;
                img.onerror = resolve;
              })
          )
        );

      // 3. Précharge les audios principaux
      const audioUrls = [
        // SOUND DESIGN
        audios.background_music,
        audios.clickBuzzer,
        audios.piano,
        audios.swoosh_intro_cloud,
        audios.swoosh_computer_in,
        audios.swoosh_computer_out,
        audios.door_opening,
        // AUDIO HUB SCENE
        audios.introduction,
        audios.mail_accepte,
        audios.mail_superflamme,
        audios.transition_nuage,
        audios.fragments_etoiles,
      ];
      const loadAudios = () =>
        Promise.all(
          audioUrls.map(
            (src) =>
              new Promise((resolve) => {
                const audio = new window.Audio();
                audio.preload = "auto";
                audio.src = src;
                // Il arrive parfois que canplaythrough ne soit jamais appelé, donc on met un fallback timeout
                let resolved = false;
                const done = () => {
                  if (!resolved) {
                    resolved = true;
                    resolve();
                  }
                };
                audio.oncanplaythrough = done;
                audio.onerror = done;
                setTimeout(done, 2000);
              })
          )
        );

      // 4. Précharge les polices (fonts)
      const fontUrls = [
        "./fonts/Poppins-SemiBold.woff2",
        "./fonts/Poppins-Regular.woff2",
        "./fonts/DKPardesi.woff2",
      ];
      const loadFonts = () =>
        Promise.all(
          fontUrls.map(
            (src) =>
              new Promise((resolve) => {
                const font = new FontFace("preload", `url(${src})`);
                font.load().then(resolve).catch(resolve);
              })
          )
        );

      // 5. Précharge les sous-titres (SRT)
      const srtUrls = [
        subtitles.introduction,
        subtitles.mail_accepte,
        subtitles.mail_superflamme,
        subtitles.transition_nuage,
        subtitles.fragments_etoiles,
        // Ajoute ici tous les .srt nécessaires pour la scène principale
      ];
      const loadSrts = () =>
        Promise.all(
          srtUrls.map((src) =>
            fetch(src)
              .then((res) => (res.ok ? res.text() : null))
              .catch(() => null)
          )
        );

      await Promise.all([loadImages(), loadAudios(), loadFonts(), loadSrts()]);

      if (isMounted) setLoaded(true);
    }

    preload();

    return () => {
      isMounted = false;
    };
  }, []);

  return loaded;
}
